// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  description: string,
  subTitle?: string,
  callToAction?: Component,
  className?: string,
};

export const SectionIntro = (props: Props) => {
  const { title, subTitle, description, callToAction, className } = props;
  const containerClass = classNames('section-intro', className);
  return (
    <div className={containerClass}>
      <div>
        {subTitle && <h3>{subTitle}</h3>}
        <h1>{title}</h1>
        <p>{description}</p>
        {callToAction}
      </div>
    </div>
  );
};
